<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title" v-if="did">{{did.short_name}}</h4>
                                <h5 class="card-subtitle"> Please keep your profile information always current in order
                                    to help you when you contact us. </h5>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <a :href="$BORLAUG + '/identity/did:bws:' + reportid.toString().substring(2, reportid.length)"
                                   target="_blank">
                                    <img class="bws-ico" src="@/assets/images/orange_bws_logo.png">&nbsp;&nbsp;View on
                                    Blockchain</a>
                            </div>
                        </div>
                        <ul class="nav nav-tabs mt-4" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#basicinfo" role="tab">
                                    <span class="hidden-sm-up">
                                        </span>
                                    <i class="ti-user"></i>
                                    <span class="hidden-xs-down ml-1">Basic Info</span>
                                </a>
                            </li>
                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#test" role="tab"><span
                                    class="hidden-sm-up"> <i class="ti-briefcase"></i></span> <span
                                    class="hidden-xs-down ml-1">Test Reports</span></a></li>
                        </ul>
                    </div>
                    <form class="form-horizontal">
                        <div class="tab-content tabcontent-border">
                            <div class="tab-pane active" id="basicinfo" role="tabpanel">
                                <basic-info :did_attachments="did_attachments" :did_records="did_records"
                                            :reportid="reportid"></basic-info>
                            </div>
                            <div class="tab-pane" id="test" role="tabpanel">
                                <test-report :reportid="reportid"
                                             :service_list="service_list"
                                             :value_chain_list="value_chain_list"></test-report>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer text-right">
                        <button @click="printReport" class="btn btn-info"><i class="fas fa-print"></i> Print</button>
                    </div>
                </div>
            </div>
        </div>
        <print-quality-report :service_list="service_list" :did="reportid" :org="org" :claims="claims" :did_records="did_records" :table_headers="table_headers"></print-quality-report>
    </div>
</template>

<style scoped>

</style>
<script>
    import BasicInfo from "./tabs/BasicInfo";
    import TestReport from "./tabs/TestReport";
    import {mapGetters} from "vuex";
    import PrintQualityReport from "./PrintQualityReport";
    import moment from "moment";

    export default {
        name: "ViewQualityReport",
        props: ['catalogid', 'reportid'],
        components: {PrintQualityReport, TestReport, BasicInfo},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                did: null,
                did_records: [],
                claims: [],
                value_chain_list: [],
                value_chain_items: [],
                service_list: [],
                service_items: [],
                did_attachments: [],
                template_attributes: [],
                printObject: {
                    samples: [],
                    test_results: []
                },
                org: null,
                table_headers: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getActiveDidTemplate();
                await Promise.all([
                    this.getDid(),
                    this.getDidRecords(),
                    this.getClaims(),
                    this.getDidAttachments(),
                    this.getOrg()
                ])
            },
            async getOrg() {
                try {
                    let {data} = await this.$http.get(`org/${this.currentOrg.id}/profile`);
                    this.org = data;
                }catch (e) {

                }
            },
            async getActiveDidTemplate() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalogid}/active_did_template`);
                    this.template_attributes = data.template ? data.template_fields : [];
                } catch (e) {
                }
            },
            async getDid() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalogid}/dids/${this.reportid}`);
                    this.did = data;
                } catch (e) {
                }
            },
            async getDidRecords() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$identity.get(`/identity/dids/${this.reportid}/properties?page=0&per_page=1000`);
                    let did_records = data.property_list.filter(p => (p.fact.value.length !== 66 && p.fact.value.indexOf('0x') !== 0));
                    let result = [];
                    let extra = [];
                    let self = this;
                    if (this.template_attributes.length > 0) {
                        this.template_attributes.forEach(function (key, index) {
                            let found = false;
                            did_records = did_records.filter(function (item) {
                                if (!found && item.name === key.name) {
                                    result.push(item);
                                    found = true;
                                    return false;
                                } else
                                    return true;
                            });
                            if (index === self.template_attributes.length - 1) {
                                extra = did_records;
                            }
                        });
                    } else {
                        result = did_records;
                    }
                    this.did_records = [...result, ...extra];
                } catch (e) {
                    console.error(e)
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getClaims() {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${this.reportid}/claims?page=0&per_page=1000`);
                    this.claims = data.claims;
                    let miscellaneous_name_index = 0, miscellaneous_item_index = 0;
                    data.claims.forEach(claim => {
                        let found_service = claim.statements.find(value_chain => value_chain.name.toLowerCase().indexOf('testing type') !== -1);
                        let status = null;
                        if (!claim.expiry && claim.current_attestations_count === 0) {
                            status = 'Pending';
                        } else if (moment(claim.expiry) >= moment()) {
                            status = 'Attested';
                        } else {
                            status = 'Expired';
                        }
                        if (found_service) {
                            if(this.table_headers.length === 0){
                                this.table_headers = claim.statements.map(s=> s.name);
                            }
                            let index_to_change = null;
                            let exist_service = this.service_list.find((sl, i) => {
                                index_to_change = i;
                                return sl.name === found_service.fact.value
                            });
                            if (exist_service) {
                                this.service_list[index_to_change].items.push({
                                    claim: claim.claim,
                                    description: claim.description,
                                    status: status,
                                    created_by: claim.created_by,
                                    attested_by: claim.attested_by,
                                    created: claim.created,
                                    expiry: claim.expiry,
                                    items: claim.statements.filter(s => (s.name !== found_service.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                    attachments: claim.attachments ? claim.attachments : []
                                })
                            } else {
                                this.service_list.push({
                                    claim: claim.claim,
                                    name: found_service.fact.value,
                                    items: [{
                                        claim: claim.claim,
                                        description: claim.description,
                                        status: status,
                                        created_by: claim.created_by,
                                        attested_by: claim.attested_by,
                                        created: claim.created,
                                        expiry: claim.expiry,
                                        items: claim.statements.filter(s => (s.name !== found_service.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                        attachments: claim.attachments ? claim.attachments : []
                                    }]
                                })
                            }
                        } else {
                            if (miscellaneous_name_index === 0) {
                                this.service_list.push({
                                    claim: claim.claim,
                                    name: 'Others',
                                    items: [{
                                        claim: claim.claim,
                                        description: claim.description,
                                        status: status,
                                        created_by: claim.created_by,
                                        attested_by: claim.attested_by,
                                        created: claim.created,
                                        expiry: claim.expiry,
                                        items: claim.statements.filter(s => (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                        attachments: claim.attachments ? claim.attachments : []
                                    }]
                                })
                                miscellaneous_name_index++;
                            } else {
                                let index_to_change = null;
                                this.service_list.find((vcl, i) => {
                                    index_to_change = i;
                                    return vcl.name === 'Others'
                                });
                                this.service_list[index_to_change].items.push({
                                    claim: claim.claim,
                                    description: claim.description,
                                    status: status,
                                    created_by: claim.created_by,
                                    attested_by: claim.attested_by,
                                    created: claim.created,
                                    expiry: claim.expiry,
                                    items: claim.statements.filter(s => (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                    attachments: claim.attachments ? claim.attachments : []
                                })
                            }
                        }
                    })
                    console.log(JSON.stringify(this.service_list));
                } catch (e) {
                    console.error(e)
                }
            },
            async getDidAttachments() {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${this.reportid}/documents`);
                    this.did_attachments = data.did_attachment_list;
                } catch (e) {
                }
            },
            printReport() {
                this.$htmlToPaper('printMe');
            },
        }
    }
</script>
